import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconDescription = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M6 3h8l4 4v14H6z' />
      <path d='M14 3v4h4M9 12h6M9 16h6' />
    </g>
  </SDIcon>
)

export default IconDescription
